"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import React, { useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import { useState } from "react";
const ProductsImagePopup = t0 => {
  const $ = _c(53);
  const {
    onClose,
    labels
  } = t0;
  const splideRef = useRef();
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
      document.body.style.overflow = "hidden";
      return _temp;
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (splideRef.current) {
        splideRef.current.go("-1");
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handlePrevClick = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (splideRef.current) {
        splideRef.current.go("+1");
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleNextClick = t4;
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const totalImages = labels?.length || 0;
  const isFirst = currentSlideIndex === 0;
  const isLast = currentSlideIndex === totalImages - 1;
  const hasMultiple = totalImages > 1;
  if (!mounted) {
    return null;
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute inset-0 bg-black/60" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = currentSlideIndex + 1;
  let t7;
  if ($[5] !== t6 || $[6] !== totalImages) {
    t7 = <h2 className="text-sm sm:text-base font-semibold font-poppins text-gray-900">Image {t6} of {totalImages}</h2>;
    $[5] = t6;
    $[6] = totalImages;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== onClose) {
    t9 = <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors">{t8}</button>;
    $[9] = onClose;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t7 || $[12] !== t9) {
    t10 = <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0">{t7}{t9}</div>;
    $[11] = t7;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      perPage: 1,
      gap: "1rem",
      mediaQuery: "max",
      pagination: false,
      arrows: false
    };
    t12 = (splide, props) => {
      setCurrentSlideIndex(props.index);
    };
    $[14] = t11;
    $[15] = t12;
  } else {
    t11 = $[14];
    t12 = $[15];
  }
  let t13;
  if ($[16] !== labels) {
    t13 = labels.map(_temp3);
    $[16] = labels;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13) {
    t14 = <div className="flex-1 sm:flex-none w-full h-auto sm:h-[400px] bg-gray-50 flex items-center justify-center"><Splide options={t11} onActive={t12} ref={splideRef} className="w-full h-full">{t13}</Splide></div>;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== currentSlideIndex || $[21] !== hasMultiple || $[22] !== labels) {
    t15 = hasMultiple && labels.map((_, index_0) => <button key={index_0} onClick={() => splideRef.current?.go(index_0)} className={`rounded-full transition-all ${index_0 === currentSlideIndex ? "w-6 h-2 bg-[#354EF0]" : "w-2 h-2 bg-gray-300 hover:bg-gray-400"}`} />);
    $[20] = currentSlideIndex;
    $[21] = hasMultiple;
    $[22] = labels;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t15) {
    t16 = <div className="flex items-center gap-1.5">{t15}</div>;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  const t17 = isFirst || !hasMultiple;
  const t18 = `w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center rounded-full border transition-colors ${isFirst || !hasMultiple ? "border-gray-100 bg-gray-50 cursor-not-allowed" : "border-gray-200 hover:bg-gray-100 cursor-pointer"}`;
  const t19 = isFirst || !hasMultiple ? "#D1D5DB" : "#4B4B4B";
  let t20;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <polyline points="15 18 9 12 15 6" />;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t19) {
    t21 = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={t19} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{t20}</svg>;
    $[27] = t19;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== t17 || $[30] !== t18 || $[31] !== t21) {
    t22 = <button onClick={handlePrevClick} disabled={t17} className={t18}>{t21}</button>;
    $[29] = t17;
    $[30] = t18;
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  const t23 = isLast || !hasMultiple;
  const t24 = `w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center rounded-full border transition-colors ${isLast || !hasMultiple ? "border-gray-100 bg-gray-50 cursor-not-allowed" : "border-gray-200 hover:bg-gray-100 cursor-pointer"}`;
  const t25 = isLast || !hasMultiple ? "#D1D5DB" : "#4B4B4B";
  let t26;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <polyline points="9 18 15 12 9 6" />;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] !== t25) {
    t27 = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={t25} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{t26}</svg>;
    $[34] = t25;
    $[35] = t27;
  } else {
    t27 = $[35];
  }
  let t28;
  if ($[36] !== t23 || $[37] !== t24 || $[38] !== t27) {
    t28 = <button onClick={handleNextClick} disabled={t23} className={t24}>{t27}</button>;
    $[36] = t23;
    $[37] = t24;
    $[38] = t27;
    $[39] = t28;
  } else {
    t28 = $[39];
  }
  let t29;
  if ($[40] !== t22 || $[41] !== t28) {
    t29 = <div className="flex items-center gap-2">{t22}{t28}</div>;
    $[40] = t22;
    $[41] = t28;
    $[42] = t29;
  } else {
    t29 = $[42];
  }
  let t30;
  if ($[43] !== t16 || $[44] !== t29) {
    t30 = <div className="flex justify-between items-center px-4 py-3 border-t border-gray-100 flex-shrink-0 bg-white sm:rounded-b-2xl">{t16}{t29}</div>;
    $[43] = t16;
    $[44] = t29;
    $[45] = t30;
  } else {
    t30 = $[45];
  }
  let t31;
  if ($[46] !== t10 || $[47] !== t14 || $[48] !== t30) {
    t31 = <div className="relative w-full h-full sm:h-auto sm:max-w-[620px] bg-white sm:rounded-2xl shadow-2xl flex flex-col sm:mx-4" onClick={_temp2}>{t10}{t14}{t30}</div>;
    $[46] = t10;
    $[47] = t14;
    $[48] = t30;
    $[49] = t31;
  } else {
    t31 = $[49];
  }
  let t32;
  if ($[50] !== onClose || $[51] !== t31) {
    t32 = createPortal(<div className="fixed inset-0 z-[9999] flex justify-center items-end sm:items-center" onClick={onClose}>{t5}{t31}</div>, document.body);
    $[50] = onClose;
    $[51] = t31;
    $[52] = t32;
  } else {
    t32 = $[52];
  }
  return t32;
};
export default ProductsImagePopup;
function _temp() {
  document.body.style.overflow = "";
}
function _temp2(e) {
  return e.stopPropagation();
}
function _temp3(label, index) {
  return <SplideSlide key={index}><div className="w-full h-[300px] sm:h-[400px] flex items-center justify-center p-4"><Image src={label.url} alt={label.alt} height={400} width={540} className="max-w-full max-h-full object-contain rounded-lg" /></div></SplideSlide>;
}